export function trackLink(linkId) {
    if (window.utag) {
        window.utag.link({
            event_name: 'link_click',
            link_tracking: linkId
        });
    }
}

export function trackPageView(viewObject) {
    if (window.utag) {
        window.utag.view(viewObject);
    } else {
        retryTracking(viewObject);
    }
}

function retryTracking(viewObject){
  setTimeout(() => trackPageView(viewObject), 200);
}

export function getCabinInfoForTracking(cabin) {
    if (cabin == 'first' || cabin == 'First') {
        return 'F';
    } else {
        return 'MC';
    }
}
